import { useUserType } from 'hooks/useUserType';
import { FC } from 'react';

import { ExternalTileHeader } from './ExternalTileHeader';
import { InternalTileHeader } from './InternalTileHeader';

type TileHeaderProps = Readonly<{
  clientId?: string;
  clientName?: string;
  quoteId: string;

  onClosed: () => void;
}>;
export const TileHeader: FC<TileHeaderProps> = ({ quoteId, clientId, clientName, onClosed }) => {
  const userType = useUserType();
  if (userType === 'externalClient') {
    return <ExternalTileHeader quoteId={quoteId} onClosed={onClosed} />;
  }
  return <InternalTileHeader quoteId={quoteId} clientId={clientId} clientName={clientName} onClosed={onClosed} />;
};
